// storageService.js
import { decryptData, encryptData } from "./Crypto";

// Save encrypted
export const saveEncryptedSession = (key, value) => {
  const encrypted = encryptData(value);
  sessionStorage.setItem(key, encrypted);
};

// Read + decrypt
export const loadDecryptedSession = (key) => {
  const encrypted = sessionStorage.getItem(key);
  if (!encrypted) return null;

  return decryptData(encrypted);
};

// Remove
export const removeSession = (key) => {
  sessionStorage.removeItem(key);
};
